import HeaderRoot from "./HeaderRoot";
import HeaderBreadcrumb from "./HeaderBreadCrump";
import HeaderProfile from "./HeaderProfile";
import HeaderMenu from "./HeaderMenu";

const Header = {
  Root: HeaderRoot,
  Breadcrumb: HeaderBreadcrumb,
  Profile: HeaderProfile,
  Menu: HeaderMenu,
};

export default Header;
